import { useState, useEffect, useMemo } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

/* contexts */
import { Context } from '../../../context/UserContext';

import moment from 'moment';
import 'moment/locale/pt-br';

import { Stack, Button, Box, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit, Print } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

/* utils */
import { retornaData } from '../../../utils/retornaDataFormatada';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import * as DataListAPI from '../../../api/dataList';
import * as EquipeAPI from '../../../api/equipe';
import * as PessoaAPI from '../../../api/pessoa';
import * as PlantaoAPI from '../../../api/plantao';
import * as TabelaAPI from '../../../api/tabela';
import * as UsuarioAPI from '../../../api/usuario';

import Checkbox from '../../form/Checkbox';
import DataList from '../../form/DataList';
import Input from '../../form/Input';

import Select from '../../form/Select';
import SelectEmpresa from '../../form/SelectEmpresa';
import TextArea from '../../form/TextArea';

import { obterColaboradorByPessoaId } from '../../../api/rh';

function Form({
    token,
    dados,
    setDados,
    pessoaId,
    empresaId,
    empresaIds,
    parametro,
    handleSubmit,
    btnText,
    caminhoVoltar,
    optionsCargo,
    optionsNivel,
    optionsEmpresa,
    Plantonistas,
    setPlantonistas,
}) {
    const [pessoaConcluido, setPessoaConcluido] = useState({});
    const [pessoaAssinatura, setPessoaAssinatura] = useState({});
    const [pessoa, setPessoa] = useState({});
    const [parametroUsuario, setParametroUsuario] = useState({});

    //situação para submeter o formulario e evitar vários clicks
    const [isSubmitting, setIsSubmitting] = useState(false);
    //const [isDisabled, setIsDisabled] = useState(false);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const [novoColaborador, setNovoColaborador] = useState({
        inicio: dados.inicio,
        termino: dados.termino,
    });
    //Atualiza o Datalist
    const [OptionsColaborador, setOptionsColaborador] = useState([]);

    const consultaDatalistColaborador = async (empresaId, filtro, ativo, tipo) => {
        const result = await DataListAPI.dataListColaborador({ empresaId, filtro, ativo, tipo });
        return result;
    };

    // Estado para rastrear a aba ativa
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [gridAtiva, setGridAtiva] = useState('integrantes');
    //abas
    const [tabEnabled, setTabEnabled] = useState({
        cabeçalho: true,
        integrantes: true,
        observacao: true,
        assinatura: true,
    });
    /* identifica a aba atual */
    const handleSelect = (index) => {
        setAbaAtiva(index);

        // Definir qual grid será atualizada com base na aba ativa
        switch (index) {
            case 0:
                setGridAtiva('cabecalho');
                break;
            case 1:
                setGridAtiva('integrantes');
                break;
            case 2:
                setGridAtiva('observacao');
                break;
            case 3:
                setGridAtiva('assinatura');
                break;
            default:
                setGridAtiva('cabecalho');
        }
    };

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    const [rowCount, setRowCount] = useState(0);

    //table state
    const [columnFilterFns, setColumnFiltersMode] = useState(
        localStorage.columnFilterFns.length > 2 ? JSON.parse(localStorage.columnFilterFns) : []
    );
    const [columnFilters, setColumnFilters] = useState(
        localStorage.columnFilters.length > 2 ? JSON.parse(localStorage.columnFilters) : []
    );
    const [globalFilter, setGlobalFilter] = useState(() => {
        const storedFilter = localStorage.getItem('globalFilter');

        if (storedFilter && storedFilter !== 'undefined' && storedFilter.length > 2) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                console.warn('Erro ao parsear globalFilter:', e);
                return ''; // valor padrão
            }
        }
        return ''; // valor padrão
    });

    const [sorting, setSorting] = useState(localStorage.sorting.length > 2 ? JSON.parse(localStorage.sorting) : []);
    const [pagination, setPagination] = useState({
        pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
        pageSize: JSON.parse(localStorage.pagination).pageSize || 5,
    });

    //Select
    const [OptionsTipo, setOptionsTipo] = useState([]);
    const [OptionsEquipe, setOptionsEquipe] = useState({});

    //Consultas
    const consultaEquipe = async (empresaId, plantaoTipoId, ativo) => {
        const result = await EquipeAPI.retornaEquipesPorTipo(empresaId, plantaoTipoId, ativo);

        if (result.length === 0) {
            return;
        }
        if (!dados.equipeId && btnText === 'Cadastrar') {
            setDados((prev) => ({ ...prev, equipeId: result[0].id }));
            setNovoColaborador((prev) => ({
                ...prev,
                plantaoId: dados.id,
                equipeId: result[0].id,
                inicio: dados.inicio,
                termino: dados.termino,
            }));
        } else {
            setNovoColaborador((prev) => ({
                ...prev,
                plantaoId: dados.id,
                equipeId: dados.equipeId,
                inicio: dados.inicio,
                termino: dados.termino,
            }));
        }
        setOptionsEquipe(result);
    };
    const consultaTipo = async (empresaIds) => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);
        setOptionsTipo(result || []);
    };
    const parametrosUsuario = async (pessoaId) => {
        const result = await PessoaAPI.parametroUsuario(pessoaId);
        setParametroUsuario(result ?? {});
    };

    useEffect(() => {
        setPessoaAssinatura(dados?.pessoaAssinatura || {});
        setRowCount(dados?.Plantonistas?.length || 0);

        consultaTipo(empresaIds);
        setNovoColaborador({
            uuid: null,
            plantaoId: dados.id,
            pessoaId: null,
            equipeId: dados.equipeId,
            Pessoa: {
                CPForCNPJ: null,
                descricao: null,
            },
            cargoId: null,
            nivelId: null,
            falta: false,
            ferias: false,
            afastamento: false,
            horarioDiferenciado: false,
            inicio: dados.inicio,
            termino: dados.termino,
            funcao: 'Adicionar',
            ativo: true,
        });

        parametrosUsuario(pessoaId);
        // eslint-disable-next-line
    }, []);

    //gridAtiva
    useEffect(() => {
        if (gridAtiva) {
            fetchData(gridAtiva);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, gridAtiva]);

    //funções para o colaborador
    const fetchData = async (grid) => {
        // Função auxiliar para aplicar filtros e ordenação
        const applyLocalFiltersAndSorting = (data) => {
            // Aplica os filtros e ordenações locais
            let result = data;

            // Exemplo de aplicação de filtro global
            if (globalFilter) {
                result = result.filter((item) => item.name.includes(globalFilter));
            }

            // Aplicar ordenação, filtro de colunas, etc., conforme necessário
            // result.sort(...), result.filter(...), etc.

            return result;
        };

        if (!Plantonistas.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }
        let filteredData = [];

        if (dados.id) {
            if (grid === 'integrantes') {
                try {
                    PlantaoAPI.listarIntegrantes({
                        start: pagination.pageIndex * pagination.pageSize,
                        size: pagination.pageSize,
                        filters: JSON.stringify(columnFilters ?? []),
                        filtersMode: JSON.stringify(columnFilterFns ?? []),
                        globalFilter: globalFilter ?? '',
                        sorting: JSON.stringify(sorting ?? []),
                        plantaoId: dados.id,
                    }).then((response) => {
                        setPlantonistas(response.data);
                        setRowCount(response.meta.totalRowCount);
                    });
                } catch (error) {
                    setIsError(true);
                    console.error(error);
                    return;
                }
            }
        } else {
            if (grid === 'integrantes') {
                filteredData = applyLocalFiltersAndSorting(Plantonistas);

                setPlantonistas(filteredData);
                setRowCount(Plantonistas.length);
            }
            filteredData = applyLocalFiltersAndSorting(Plantonistas);
        }

        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    useEffect(() => {
        setTabEnabled((prevTabEnabled) => ({ ...prevTabEnabled, assinatura: parametroUsuario.plantaoAssinatura }));
    }, [parametroUsuario.plantaoAssinatura]);

    useEffect(() => {
        //atualizar a tabela pessoa com as tabels filhas
        setDados((prev) => {
            return {
                ...prev,
                Plantonistas: Plantonistas,
            };
        });
    }, [Plantonistas]);

    useEffect(() => {
        consultaEquipe(dados.empresaId, dados.plantaoTipoId, null);

        // eslint-disable-next-line
    }, [dados.empresaId, dados.plantaoTipoId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await obterColaboradorByPessoaId({ pessoaId: novoColaborador.pessoaId, consultaDia: dados.data });

                setNovoColaborador((prev) => ({
                    ...prev,
                    Pessoa: data?.Pessoa,
                    cargoId: data?.cargoId,
                    nivelId: data?.nivelId,
                    ferias: data?.feriasAtiva,
                    Setor: data?.Setor,
                    rhCargo: data?.rhCargo,
                    rhNivel: data?.rhNivel,
                }));
            } catch (error) {
                console.error('Erro ao buscar colaborador:', error);
            }
        };

        if (novoColaborador.pessoaId) {
            setIsSubmitting(true);
            fetchData();
        } else {
            setIsSubmitting(false);
        }
    }, [novoColaborador.pessoaId]);

    //novo useEffect com retorno de informações do integrante da equipe
    useEffect(() => {
        if (btnText !== 'Cadastrar' || !dados.equipeId) return;

        let isCancelled = false;

        // ===== Helpers =====
        const toBool = (v) => v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true';

        const buildDateTime = (dateStr, timeStr) => {
            // aceita "HH:mm", "HH:mm:ss", "YYYY-MM-DD HH:mm[:ss]" ou ISO
            const fmts = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', moment.ISO_8601, 'HH:mm:ss', 'HH:mm'];
            if (!timeStr) return null;

            // Se veio só hora, prefixa data do dia
            if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(String(timeStr).trim())) {
                return moment(`${dateStr} ${timeStr}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);
            }
            // Caso já seja datetime/ISO
            return moment(timeStr, fmts, true);
        };

        // Normaliza um par (inicio, termino) com base em strings e flags
        const computeWindow = ({
            baseDate,
            inicioRaw,
            terminoRaw,
            outroDiaFlag,
            fallbackStart,
            fallbackEnd,
            minimalFix = false,
        }) => {
            let mI = buildDateTime(baseDate, inicioRaw);
            let mT = buildDateTime(baseDate, terminoRaw);

            // Se inválidos, usa fallback pré-calculado
            if (!mI?.isValid() || !mT?.isValid()) {
                mI = fallbackStart.clone();
                mT = fallbackEnd.clone();
                return { mI, mT };
            }

            // Ajuste "outro dia"
            if (toBool(outroDiaFlag)) {
                mT.add(1, 'day');
            }

            // Garante janela válida
            if (!mT.isAfter(mI)) {
                // Heurística:
                // - Se marcou outroDia, já ajustamos acima.
                // - Se não marcou, mas é cross-midnight implícito (ex.: 21:00 -> 07:00), soma 1 dia.
                // - Caso contrário (igual ou anterior por erro), aplica fix mínimo (1h).
                if (mT.format('HH:mm') !== mI.format('HH:mm')) {
                    mT.add(1, 'day');
                } else if (minimalFix) {
                    mT.add(1, 'hour');
                } else {
                    // padrão seguro
                    mT.add(1, 'day');
                }
            }

            return { mI, mT };
        };

        (async () => {
            try {
                const id = dados.equipeId;
                const [equipe, integrantesResp] = await Promise.all([
                    EquipeAPI.obterEquipeById(id),
                    EquipeAPI.retornaIntegrantes(id),
                ]);

                const hoje = moment().format('YYYY-MM-DD');

                // ===== Janela padrão da equipe =====
                const equipeOutroDia = toBool(equipe?.outroDia);
                const horaInicioEquipe = equipe?.inicio || '07:00';
                const horaTerminoEquipe = equipe?.termino || '17:00';

                // Fallback antigo (07–17 / 21–07) se equipe estiver inválida
                const calcFallbackEquipe = () => {
                    const horaAtual = moment().format('HH:mm');
                    if (horaAtual > '07:00' && horaAtual <= '17:00') {
                        return {
                            mI: moment(`${hoje} 07:00`, 'YYYY-MM-DD HH:mm'),
                            mT: moment(`${hoje} 17:00`, 'YYYY-MM-DD HH:mm'),
                        };
                    }
                    return {
                        mI: moment(`${hoje} 21:00`, 'YYYY-MM-DD HH:mm'),
                        mT: moment(`${hoje} 07:00`, 'YYYY-MM-DD HH:mm').add(1, 'day'),
                    };
                };

                let { mI: equipeI, mT: equipeT } = computeWindow({
                    baseDate: hoje,
                    inicioRaw: horaInicioEquipe,
                    terminoRaw: horaTerminoEquipe,
                    outroDiaFlag: equipeOutroDia,
                    ...calcFallbackEquipe(),
                    minimalFix: true,
                });

                const inicioEquipeFmt = equipeI.format('YYYY-MM-DD HH:mm:ss');
                const terminoEquipeFmt = equipeT.format('YYYY-MM-DD HH:mm:ss');

                if (isCancelled) return;

                // Atualiza o formulário com o horário padrão da equipe
                setDados((prev) => ({
                    ...prev,
                    inicio: inicioEquipeFmt,
                    termino: terminoEquipeFmt,
                    outroDia: Boolean(equipeOutroDia),
                }));

                if (integrantesResp?.message) {
                    setFlashMessage(integrantesResp.message, integrantesResp.type);
                }

                const arr = Array.isArray(integrantesResp?.data) ? integrantesResp.data : [];

                // ===== Mapeia integrantes com possível horário diferenciado =====
                const integrantes = arr.map((item) => {
                    const horarioDiferenciado = toBool(item?.horarioDiferenciado);
                    const outroDiaInd = toBool(item?.outroDia);
                    const custoFixo = toBool(item?.custoFixo);

                    let mI = equipeI.clone();
                    let mT = equipeT.clone();

                    if (horarioDiferenciado) {
                        const { mI: iI, mT: iT } = computeWindow({
                            baseDate: hoje,
                            inicioRaw: item?.inicio, // pode vir "HH:mm" ou datetime
                            terminoRaw: item?.termino, // idem
                            outroDiaFlag: outroDiaInd,
                            fallbackStart: equipeI,
                            fallbackEnd: equipeT,
                            minimalFix: true,
                        });
                        mI = iI;
                        mT = iT;
                    }

                    return {
                        equipeId: item?.equipeId,
                        Pessoa: item?.Pessoa,
                        rhCargo: item?.rhCargo,
                        rhNivel: item?.rhNivel,

                        pessoaId: item?.pessoaId,
                        cargoId: item?.cargoId,
                        nivelId: item?.nivelId,
                        afastamento: item?.afastamento,
                        ferias: false,
                        falta: false,
                        ativo: item?.ativo,

                        // horários finais definidos
                        inicio: mI.format('YYYY-MM-DD HH:mm:ss'),
                        termino: mT.format('YYYY-MM-DD HH:mm:ss'),

                        // flags/atributos adicionais úteis no front/back
                        horarioDiferenciado,
                        outroDia: outroDiaInd,
                        custoFixo,
                    };
                });

                setPlantonistas(integrantes);
            } catch (error) {
                console.error(error);
                setFlashMessage(
                    error?.response?.data?.message || 'Erro ao carregar equipe/plantonistas.',
                    error?.response?.data?.type || 'error'
                );
            } finally {
                if (!isCancelled) limparNovoColaborador();
            }
        })();

        return () => {
            isCancelled = true;
        };
        // eslint-disable-next-line
    }, [btnText, dados.equipeId]);

    useEffect(() => {
        setDados((prev) => ({
            ...prev,
            concluidoData: dados.concluido === true ? moment().format('YYYY-MM-DD HH:mm:ss') : null,
            pessoaId: dados.concluido === true ? localStorage.getItem('pessoaId') : null,
        }));
        setPessoaConcluido((prevPessoaConcluido) => ({
            ...prevPessoaConcluido,
            descricao: dados.concluido === true ? localStorage.getItem('nome') : null,
        }));
    }, [dados.concluido]);

    //funções
    const handleEditarOrDeletar = async (originalRow, row, funcao) => {
        // Define os dados para o novo produto
        const newData = {
            index: row,
            id: originalRow.id,
            uuid: originalRow.uuid,
            Pessoa: originalRow.Pessoa,
            rhCargo: originalRow.rhCargo,
            rhNivel: originalRow.rhNivel,

            afastamento: originalRow.afastamento,
            falta: originalRow.falta,
            ferias: originalRow.ferias,

            plantaoId: originalRow.plantaoId,
            equipeId: originalRow.equipeId,
            pessoaId: originalRow.pessoaId,
            cargoId: originalRow.cargoId,
            nivelId: originalRow.nivelId,

            horarioDiferenciado: originalRow.horarioDiferenciado,
            inicio: originalRow.inicio,
            termino: originalRow.termino,
            horarioDiferenciado: originalRow.horarioDiferenciado,
            custoFixo: originalRow.custoFixo,
            observacao: originalRow.observacao,

            ativo: originalRow.ativo,
            funcao: funcao,
            index: row,
        };

        // Atualize o estado do novo objeto
        setPessoa(originalRow.Pessoa);
        setNovoColaborador(newData);

        return;
    };
    const handleColaborador = async (obj) => {
        // Campos obrigatórios
        const obrigatorios = ['plantaoId', 'equipeId', 'pessoaId', 'cargoId', 'nivelId'];

        // Preenche dados ausentes herdando de `dados`
        const atualizado = {
            ...dados,
            ...novoColaborador, // sobrescreve os de dados com os informados em novoColaborador
        };

        // Atualiza estado
        setNovoColaborador(atualizado); // atualiza estado (assíncrono)

        // Normaliza função
        const funcao = atualizado.funcao?.toLowerCase();

        const inicioData = moment(atualizado.inicio).local();
        const terminoData = moment(atualizado.termino).local();

        if (!inicioData.isValid() || !terminoData.isValid()) {
            setFlashMessage('As datas de início ou término são inválidas!', 'warning');
            return;
        }

        if (inicioData.isAfter(terminoData)) {
            setFlashMessage('A data de início não pode ser maior que a data de término!', 'warning');
            return;
        }

        if (dados.id) {
            //validação do novo colaborador
            for (const campo of obrigatorios) {
                if (!atualizado[campo]) {
                    const nomesCampos = {
                        plantaoId: 'Plantão',
                        equipeId: 'Equipe',
                        pessoaId: 'Colaborador',
                        cargoId: 'Cargo',
                        nivelId: 'Nível',
                    };
                    setFlashMessage(`Campo '${nomesCampos[campo]}' é obrigatório.`, 'error');
                    return;
                }
            }

            // Caso esteja lidando com integração com backend
            const result = await PlantaoAPI.integrantes(atualizado);

            const { data } = result;

            setFlashMessage(data.message, data.type);

            if (data?.integrantes) {
                setPlantonistas(data.integrantes);
            }
        } else {
            // Ações locais conforme função (editar, deletar, adicionar)
            setPlantonistas((prev) => {
                const novos = [...prev];

                if (funcao === 'editar') {
                    novos[atualizado.index] = {
                        ...novos[atualizado.index],
                        ...atualizado,
                    };
                } else if (funcao === 'deletar') {
                    novos.splice(atualizado.index, 1);
                } else {
                    novos.push({
                        uuid: atualizado.uuid,
                        equipeId: atualizado.equipeId || dados.equipeId,
                        pessoaId: atualizado.pessoaId,
                        cargoId: atualizado.cargoId,
                        nivelId: atualizado.nivelId,
                        afastamento: atualizado.afastamento,
                        falta: atualizado.falta,
                        ferias: atualizado.ferias,
                        horarioDiferenciado: atualizado.horarioDiferenciado,
                        inicio: atualizado.inicio,
                        termino: atualizado.termino,
                        custoFixo: atualizado.custoFixo,
                        observacao: atualizado.observacao,
                        ativo: atualizado.ativo,
                        Pessoa: atualizado.Pessoa,
                    });
                }

                return novos;
            });
        }

        limparNovoColaborador();
    };

    const limparNovoColaborador = () => {
        setNovoColaborador({
            uuid: null,
            plantaoId: dados.id,
            equipeId: dados.equipeId,
            pessoaId: null,
            cargoId: null,
            nivelId: null,
            afastamento: false,
            falta: false,
            ferias: false,

            horarioDiferenciado: false,
            inicio: dados.inicio,
            termino: dados.termino,
            custoFixo: false,
            observacao: '',

            funcao: 'Adicionar',
            Pessoa: { CPForCNPJ: null, descricao: null },
            ativo: true,
        });
        setPessoa({});
        setOptionsColaborador({
            id: null,
            descricao: null,
        });
    };
    const confirmarAssinatura = async () => {
        const result = await UsuarioAPI.assinatura({
            empresaIds: empresaIds,
            empresaId: dados.empresaId,
            usuario: dados.usuario,
            senha: dados.senha,
            uuid: dados.uuid,
            tabela: 'Plantao',
        });
        if (result.type === 'success') {
            setFlashMessage(result.message, result.type);

            setDados((prev) => {
                return {
                    ...prev,
                    assinado: result.data.tabelaAssinada.assinado,
                    dataAssinatura: moment(result.data.tabelaAssinada.dataAssinatura).format('YYYY-MM-DD HH:mm:ss'),
                    pessoaIdAssinatura: result.data.tabelaAssinada.pessoaIdAssinatura,
                    usuarioAssinado: result.data.descricao,
                    usuario: null,
                    senha: null,
                };
            });
        } else if (result.type === 'warning') {
            setFlashMessage(result.message, result.type);
        } else {
            setFlashMessage(result.response.data.message, result.response.data.type);
        }
    };

    async function handleChange(e) {
        const { name, value, checked, type, options, selectedIndex } = e.target;

        if (name === 'tipo') {
            setDados({
                ...dados,
                [name]: options[selectedIndex].text,
            });
        } else if (name.startsWith('novoColaborador')) {
            if (name.split('.')[1] === 'cargo') {
                setNovoColaborador({
                    ...novoColaborador,
                    cargo: options[selectedIndex].text,
                });
            } else {
                setNovoColaborador({ ...novoColaborador, [name.split('.')[1]]: type === 'checkbox' ? checked : value });
            }
        } else if (name.startsWith('Pessoa')) {
            setPessoa({
                ...pessoa,
                [name.split('.')[1]]: value,
            });

            const result = await consultaDatalistColaborador(dados.empresaId, value, true, null);
            setOptionsColaborador(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;
            //verifica se existe
            setNovoColaborador((prevState) => ({
                ...prevState,
                pessoaId: selectedId ?? null,
            }));
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }
    async function handleOnBlur(e) {
        const { name, value, checked, type, options, selectedIndex } = e.target;
        //verifica duplicidade
        if (name.startsWith('Pessoa.')) {
            if (name.split('.')[1] === 'descricao') {
                Plantonistas.forEach((pl, index) => {
                    if (parseInt(pl.pessoaId) === parseInt(novoColaborador.pessoaId)) {
                        setNovoColaborador((prevState) => ({
                            ...prevState,
                            index: index,
                            uuid: pl.uuid,
                            cargoId: pl.cargoId,
                            nivelId: pl.nivelId,
                            afastamento: pl.afastamento,
                            ferias: pl.ferias,
                            falta: pl.falta,
                            horarioDiferenciado: pl.horarioDiferenciado,
                            inicio: pl.inicio,
                            termino: pl.termino,
                            custoFixo: pl.custoFixo,
                            observacao: pl.observacao,
                            ativo: pl.ativo,
                            funcao: 'Editar',
                        }));
                    }
                });
            }
        }
    }

    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        if (isSubmitting) return; // evita clique duplo
        setIsSubmitting(true);

        handleSubmit(dados);
    };
    const columns = useMemo(
        () => [
            {
                id: 'integrantes',
                header: `Integrantes da equipe de plantão`,
                columns: [
                    {
                        accessorKey: 'Pessoa.CPForCNPJ',
                        header: 'CPF',
                    },
                    {
                        accessorKey: 'Pessoa.descricao',
                        header: 'Colaborador',
                    },
                    {
                        accessorKey: 'rhCargo.descricao',
                        header: 'Cargo',
                    },
                    {
                        accessorKey: 'rhNivel.descricao',
                        header: 'Cargo',
                    },
                    {
                        accessorKey: 'afastamento',
                        header: 'Afastamento',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.afastamento ? 'Sim' : '';
                        },
                    },
                    {
                        accessorKey: 'falta',
                        header: 'Falta',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.falta ? 'Falta' : '';
                        },
                    },
                    {
                        accessorKey: 'ferias',
                        header: 'Férias',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.ferias ? 'Férias' : '';
                        },
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Ativo', value: 1 },
                            { label: 'Inativo', value: 0 },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'center',
                            onClick: () => {},
                        }),
                        Cell: ({ row }) => {
                            return row.original.ativo ? 'Ativo' : 'Inativo';
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [Plantonistas]
    );
    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <Tabs selectedIndex={abaAtiva} onSelect={handleSelect}>
            <form onSubmit={submit}>
                <h1>Plantão nº {dados.codigo ? dados.codigo : null}</h1>
                <TabList>
                    <Tab disabled={!tabEnabled.cabeçalho} title={'Cabeçalho do Plantão'}>
                        Cabeçalho
                    </Tab>
                    <Tab disabled={!tabEnabled.integrantes} title={'Integrantes do Plantão'}>
                        Integrantes
                    </Tab>
                    <Tab disabled={!tabEnabled.observacao} title={'Observações durante o Plantão'}>
                        Observações
                    </Tab>
                    <Tab disabled={!tabEnabled.assinatura} title={'Assinatura do Plantão'}>
                        Assinatura
                    </Tab>
                </TabList>
                <TabPanel>
                    {btnText !== 'Cadastrar' && (
                        <div>
                            <Input
                                text="Data Cadastro"
                                type="datetime-local"
                                name="createdAt"
                                placeholder="última atualização"
                                title="Data de inserção do cadastro no sistema"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={moment(dados.createdAt).format('YYYY-MM-DD HH:mm:ss') ?? ''}
                                readonly={true}
                                inputWidth={'150px'}
                            />
                            <Input
                                text="Data Atualização"
                                type="datetime-local"
                                name="updatedAt"
                                placeholder="última atualização"
                                title="Data da última atualização dos dados"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={moment(dados.updatedAt).format('YYYY-MM-DD HH:mm:ss') ?? ''}
                                readonly={true}
                                inputWidth={'150px'}
                            />
                            {parametroUsuario.plantaoPermiteConcluir === true && (
                                <>
                                    <Checkbox
                                        title="Informa que o plantão foi concluído"
                                        text="Concluído"
                                        name="concluido"
                                        handleOnChange={handleChange}
                                        value={dados.concluido}
                                        disabled={!parametroUsuario.plantaoPermiteConcluir}
                                        checked={!!dados.concluido}
                                    />
                                    <Input
                                        text="Data Conclusão"
                                        type="datetime-local"
                                        name="concluidoData"
                                        placeholder=""
                                        title="Data de concusão do plantão"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={moment(dados.concluidoData).format('YYYY-MM-DD HH:mm:ss') ?? ''}
                                        readonly={true}
                                        inputWidth={'150px'}
                                    />
                                    <Input
                                        text="Usuário"
                                        type="text"
                                        name="pessoaConcluido.descricao"
                                        placeholder="nome do usuário"
                                        title="Digite o nome do prazo de pagamento ou recebimento"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        inputWidth="300px"
                                        value={pessoaConcluido.descricao || ''}
                                        required={false}
                                        readonly={true}
                                    />
                                </>
                            )}
                        </div>
                    )}
                    <div>
                        <SelectEmpresa
                            text="Empresa"
                            title="selecione a empresa do plantão"
                            name="empresaId"
                            options={optionsEmpresa}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={dados.empresaId}
                            required
                            notOptNull={true}
                        />
                        <Input
                            text="Data"
                            type="date"
                            name="data"
                            placeholder="Data"
                            title="Data de abertura do Plantão"
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            readonly={!parametroUsuario.plantaoAlteraData}
                            value={dados.data ? retornaData(dados.data) : ''}
                        />

                        <Input
                            text="Início"
                            type="datetime-local"
                            name="inicio"
                            placeholder=""
                            title="Início do Plantão"
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={moment(dados.inicio).format('YYYY-MM-DD HH:mm:ss') ?? ''}
                        />
                        <Input
                            text="Término"
                            type="datetime-local"
                            name="termino"
                            placeholder=""
                            title="Término do Plantão"
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={moment(dados.termino).format('YYYY-MM-DD HH:mm:ss') ?? ''}
                        />
                        <Select
                            name="plantaoTipoId"
                            title="Selecione o tipo"
                            text="Tipo"
                            inputWidth="150px"
                            options={OptionsTipo}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={dados.plantaoTipoId}
                            notOptNull={false}
                            required={true}
                        />
                        <Select
                            name="equipeId"
                            title="Selecione a equipe"
                            text="Equipe"
                            inputWidth="150px"
                            options={OptionsEquipe}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={dados.equipeId}
                            isEnum={false}
                            notOptNull={false}
                            required={true}
                        />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div
                        style={{
                            margin: '1em',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1em' }}>
                            <DataList
                                text="Colaborador"
                                name="Pessoa.descricao"
                                inputWidth="300px"
                                filteredOptions={OptionsColaborador}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.descricao || ''}
                            />
                            <Select
                                name="novoColaborador.cargoId"
                                text="Cargo"
                                options={optionsCargo}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={novoColaborador.cargoId}
                                isEnum={false}
                                notOptNull={false}
                            />
                            <Select
                                name="novoColaborador.nivelId"
                                text="Nível"
                                options={optionsNivel}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={novoColaborador.nivelId}
                                isEnum={false}
                                notOptNull={false}
                            />
                            <Checkbox
                                title="Colaborador encontra-se com algum tipo de afastamento remunerado"
                                text="Afastamento"
                                name="novoColaborador.afastamento"
                                handleOnChange={handleChange}
                                value={novoColaborador.afastamento}
                                checked={!!novoColaborador.afastamento}
                            />
                            <Checkbox
                                title="Faltou ao plantão"
                                text="Falta"
                                name="novoColaborador.falta"
                                handleOnChange={handleChange}
                                value={novoColaborador.falta}
                                checked={!!novoColaborador.falta}
                            />
                            <Checkbox
                                title="Férias"
                                text="Férias"
                                name="novoColaborador.ferias"
                                handleOnChange={handleChange}
                                value={novoColaborador.ferias}
                                checked={!!novoColaborador.ferias}
                            />
                            <Checkbox
                                title="Horário diferenciado do colaborador dentro do plantão"
                                text="Horário diferenciado"
                                name="novoColaborador.horarioDiferenciado"
                                handleOnChange={handleChange}
                                value={novoColaborador.horarioDiferenciado}
                                checked={!!novoColaborador.horarioDiferenciado}
                            />
                            {novoColaborador.horarioDiferenciado && (
                                <>
                                    <Input
                                        text="Início"
                                        type="datetime-local"
                                        name="novoColaborador.inicio"
                                        placeholder=""
                                        title="Início do Plantão"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={
                                            novoColaborador.inicio
                                                ? moment(novoColaborador.inicio).format('YYYY-MM-DD HH:mm:ss')
                                                : ''
                                        }
                                    />
                                    <Input
                                        text="Término"
                                        type="datetime-local"
                                        name="novoColaborador.termino"
                                        placeholder=""
                                        title="Término do Plantão"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={
                                            novoColaborador.termino
                                                ? moment(novoColaborador.termino).format('YYYY-MM-DD HH:mm:ss')
                                                : ''
                                        }
                                    />
                                    <Checkbox
                                        title="Indica que esse colaborador terá também um cálculo do custo operacional diferenciado, o mesmo será aplicado ao cálculo do custo fixo na empresa ou tabulado as horas dentro de cada plantão para efeito de custos operacionais"
                                        text="Custo fixo"
                                        name="novoColaborador.custoFixo"
                                        handleOnChange={handleChange}
                                        value={novoColaborador.custoFixo}
                                        checked={!!novoColaborador.custoFixo}
                                    />
                                </>
                            )}
                            <Checkbox
                                title="Ativo"
                                text="Ativo"
                                name="novoColaborador.ativo"
                                handleOnChange={handleChange}
                                value={novoColaborador.ativo}
                                checked={!!novoColaborador.ativo}
                            />
                            <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                spacing={1}
                                sx={{
                                    ml: { xs: 0, sm: 2 },
                                    mt: { xs: 2, sm: 0 },
                                    width: { xs: '100%', sm: 'auto' },
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparNovoColaborador();
                                    }}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novoColaborador.funcao === 'deletar' ? 'error' : 'info'}
                                    onClick={() => handleColaborador(novoColaborador)}
                                    disabled={
                                        !novoColaborador.pessoaId || !novoColaborador.cargoId || !novoColaborador.nivelId
                                            ? true
                                            : false
                                    }
                                    style={{ marginLeft: '5px' }}
                                >
                                    {novoColaborador.funcao}
                                </Button>
                            </Stack>
                        </div>
                        <ThemeProvider theme={theme}>
                            <MaterialReactTable
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        muiTableHeadCellProps: {
                                            align: 'center',
                                        },
                                        size: 100,
                                    },
                                    'mrt-row-numbers': {
                                        enableColumnOrdering: true, //turn on some features that are usually off
                                        enableResizing: true,
                                        muiTableHeadCellProps: {
                                            sx: {
                                                fontSize: '1.2rem',
                                            },
                                        },
                                    },
                                    'mrt-row-select': {
                                        enableColumnActions: true,
                                        enableHiding: true,
                                        size: 50,
                                    },
                                }}
                                enableColumnFilterModes
                                enableGlobalFilterModes
                                //enableColumnResizing
                                enableColumnOrdering
                                enableEditing
                                renderRowActions={({ row, table }) => (
                                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                                        <Tooltip arrow placement="top" title="Editar">
                                            <span>
                                                {' '}
                                                <IconButton
                                                    onClick={() => {
                                                        handleEditarOrDeletar(row.original, row.index, 'Editar');
                                                    }}
                                                    disabled={localStorage.getItem('editar') === 'true' ? false : true}
                                                >
                                                    <Edit />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip arrow placement="right" title="Cancelar">
                                            <span>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleEditarOrDeletar(row.original, row.id, 'Deletar')}
                                                    disabled={localStorage.getItem('cancelar') === 'true' ? false : true}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                )}
                                renderTopToolbarCustomActions={() => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '8px',
                                        }}
                                    >
                                        <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                            <div>
                                                {' '}
                                                <Button
                                                    color="secondary"
                                                    onClick={() => navigate('/TabelaPrecos/CreateOrEdit')}
                                                    variant="contained"
                                                    disabled={true}
                                                >
                                                    Novo
                                                </Button>
                                            </div>
                                        </Tooltip>
                                    </div>
                                )}
                                columns={columns}
                                data={Plantonistas}
                                enableRowSelection
                                getRowId={(row) => row.uuid}
                                manualFiltering
                                manualPagination
                                manualSorting
                                muiToolbarAlertBannerProps={
                                    isError
                                        ? {
                                              color: 'error',
                                              children: 'Error loading data',
                                          }
                                        : undefined
                                }
                                onColumnFiltersChange={setColumnFilters}
                                onColumnFilterFnsChange={setColumnFiltersMode}
                                onGlobalFilterChange={setGlobalFilter}
                                onPaginationChange={setPagination}
                                onSortingChange={setSorting}
                                rowCount={rowCount}
                                initialState={{
                                    showColumnFilters: true,
                                    density: 'compact',
                                    //columnPinning: { left: ["mrt-row-select"] },
                                }}
                                state={{
                                    columnFilterFns,
                                    columnFilters,
                                    globalFilter,
                                    isLoading,
                                    pagination,
                                    showAlertBanner: isError,
                                    showProgressBars: isRefetching,
                                    sorting,
                                }}
                                //positionToolbarDropZone={"top"}
                                positionExpandColumn={'first'}
                                positionActionsColumn={'first'}
                                positionToolbarAlertBanner="bottom"
                                localization={MRT_Localization_PT_BR}
                            />
                        </ThemeProvider>
                    </div>
                </TabPanel>
                <TabPanel>
                    <div>
                        <TextArea
                            text="Observação"
                            type="text"
                            name="observacao"
                            placeholder="Observações durante o plantão"
                            title="Observações ocorridas durante o plantão"
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={dados.observacao || ''}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>
                </TabPanel>
                <TabPanel>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '1rem',
                            padding: ' 0.7em',
                        }}
                    >
                        <Checkbox
                            title="Plantão assinado"
                            text="Assinado"
                            name="assinado"
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            value={dados.assinado}
                            disabled={true}
                            checked={!!dados.assinado}
                        />
                        {dados.assinado ? (
                            <>
                                <Input
                                    text="Usuário"
                                    type="text"
                                    name="pessoaAssinatura.descricao"
                                    inputWidth="350px"
                                    readonly={true}
                                    value={pessoaAssinatura.descricao || null}
                                />
                                <Input
                                    text="Data"
                                    type="datetime"
                                    name="pessoaAssinatura.descricao"
                                    readonly={true}
                                    value={dados.dataAssinatura ? moment(dados.dataAssinatura).format('DD/MM/YYYY HH:mm:ss') : ''}
                                />
                            </>
                        ) : (
                            <>
                                <Input
                                    text="Usuário"
                                    type="text"
                                    name="usuario"
                                    title={
                                        parametroUsuario.plantaoAssinatura
                                            ? 'Digite o nome do usuário'
                                            : 'Usuário não tem permissão para assinar o plantão'
                                    }
                                    placeholder={parametroUsuario.plantaoAssinatura ? 'Digite o usuário' : 'Sem Permissão'}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    disabled={!parametroUsuario.plantaoAssinatura}
                                    value={dados.usuario ?? ''}
                                />
                                <Input
                                    text="Senha"
                                    type="password"
                                    name="senha"
                                    title={
                                        parametroUsuario.plantaoAssinatura
                                            ? 'Digite a senha'
                                            : 'Usuário não tem permissão para assinar o plantão'
                                    }
                                    placeholder={parametroUsuario.plantaoAssinatura ? 'Digite a senha' : 'Sem Permissão'}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    disabled={!parametroUsuario.plantaoAssinatura}
                                    value={dados.senha ?? ''}
                                />

                                <Stack
                                    direction="row"
                                    spacing={2}
                                    style={{
                                        marginLeft: ' 0.7em',
                                    }}
                                >
                                    <Tooltip arrow placement="top-end" title={`Confirmar assinatura`}>
                                        <Button
                                            variant="contained"
                                            color="info"
                                            disabled={
                                                !dados.usuario || (!dados.senha && true) || !parametroUsuario.plantaoAssinatura
                                            }
                                            onClick={() => confirmarAssinatura()}
                                        >
                                            Confirmar
                                        </Button>
                                    </Tooltip>
                                </Stack>
                            </>
                        )}
                    </div>
                </TabPanel>
                <div
                    style={{
                        padding: ' 0.7em',
                    }}
                >
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="contained" color="success" disabled={isSubmitting}>
                            {btnText}
                        </Button>
                    </Stack>
                </div>
            </form>
        </Tabs>
    );
}
export default Form;
